import { jsonObject, jsonMember } from 'typedjson';

@jsonObject
export class CompanyQueryRange {
  @jsonMember
  public queryRange: number;
}
